/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Option2_BadgeInputs */

const tr_landing_genius_option2_badge = /** @type {(inputs: Landing_Genius_Option2_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçenek 02`)
};

const en_landing_genius_option2_badge = /** @type {(inputs: Landing_Genius_Option2_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option 02`)
};

const de_landing_genius_option2_badge = /** @type {(inputs: Landing_Genius_Option2_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Option 02`)
};

const ru_landing_genius_option2_badge = /** @type {(inputs: Landing_Genius_Option2_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вариант 02`)
};

/**
* | output |
* | --- |
* | "Option 02" |
*
* @param {Landing_Genius_Option2_BadgeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_option2_badge = /** @type {((inputs?: Landing_Genius_Option2_BadgeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Option2_BadgeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_option2_badge(inputs)
	if (locale === "de") return de_landing_genius_option2_badge(inputs)
	if (locale === "ru") return ru_landing_genius_option2_badge(inputs)
	return tr_landing_genius_option2_badge(inputs)
});